jQuery(document).ready(function ($) {
  $(".image-slick-slider").each(function () {
    const $slider = $(this);
    const slideCount = $slider.children(".image-slick-slider-item").length;
    const desktopSlides = Math.min(3, Math.max(slideCount, 1));
    const tabletSlides = Math.min(2, Math.max(slideCount, 1));

    if (slideCount <= 1) {
      return;
    }

    $slider.slick({
      dots: false,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: false,
      slidesToShow: desktopSlides,
      centerMode: slideCount > desktopSlides,
      infinite: slideCount > desktopSlides,
      // prevent additional div - click bug
      rows: 0,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            dots: true,
            slidesToShow: tabletSlides,
            centerMode: slideCount > tabletSlides,
            infinite: slideCount > tabletSlides,
          },
        },
        {
          breakpoint: 576,
          settings: {
            dots: true,
            slidesToShow: 1,
            centerMode: false,
            variableWidth: true,
            infinite: slideCount > 1,
          },
        },
      ],
    });
  });
});
